import React from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import TextInput from "../../widgets/TextInput";
import FixButton from "../../widgets/Button";
import getStudenti from "../../services/getStudenti";
import { NineCellLoading } from 'react-loadingg';

import getEsami from "../../services/getEsami";
import setValutazione from "../../services/setValutazione";
import getValutazioni from "../../services/getValutazioni";
import EditEsame from "../../widgets/EditEsame";
import editEsame from "../../services/editEsame";
import MyDatePicker from "../../widgets/DatePicker";
import moment from "moment";
import translateString from "../../utils/Locales";
import Utils from "../../utils/utils";

let t = translateString;

export default class EsameDetails extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };
  
    this.section = this.props.section
    if (this.section == undefined){
      const pathname = props.location.pathname;
      this.section = pathname.substring(8, pathname.length);
    }

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.userslist = [];
    this.studenti = [];

    this.grid = 2;

    this.startDateRef = React.createRef();
    this.endDateRef = React.createRef();

    this.state = {
      details: [],
      insertEsameShow: false,
      editShow: false, 
      isLoading: true,
    };

  }


  async componentDidMount(){

    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    const currentCourse = cookies.get('currentCourse', { path: '/' });
    const currentEsame = cookies.get('currentEsame', { path: '/' });

    Utils.setAnalyticsPage('Exam details: ' + currentEsame + ' for course: ' + currentCourse + ' - ' + cookies.get('db', { path: '/' }));

    this.corsoId = currentCourse;
    this.esami = await getEsami(username, token, currentCourse);
    this.esame = this.esami.find(e => e.id == currentEsame);
    this.esameName = this.esame.nome;
    
    this.studenti = await getStudenti(username, token);
    this.studenti = this.studenti.filter(s => s.corsi.indexOf(currentCourse+";") != -1);
    this.studenti.sort((a, b) => (a.cognome < b.cognome || (a.cognome == b.cognome && a.nome < b.nome)) ? -1 : 1);

    this.valutazioni = await getValutazioni(username, token, this.esame.id);
    this.studenti.forEach(s => {
      var voto = this.valutazioni.find(v => v.id_studente == s.id);
      s.valutazione = voto != undefined ? voto.valutazione : -1;
      s.data_str = voto != undefined ? voto.data : '';
      s.data = (voto !== undefined && voto.data !== '') ? moment(voto.data, 'DD-MM-yyyy').toDate() : null;
    });

    this.setState({ isLoading: false });
  }

  render () {

    if (this.state.isLoading) return <NineCellLoading style={{ position: 'absolute', left: '55%', top: '50%' }} />

    if (this.esame == undefined) return <div />;
    
    return (<div>

        <PageTitle title={(this.esame.type === '1' ? t('prova_scritta') : t('prova_orale')) + (this.esame.type !== '2' ? (' ' + t('del') + ' ' + this.esame.data) : '')} button={t('modifica')} onClick={() => this.setState({editShow: true})}/>        
        <table>
        {this.studenti.map((s, index) => {
          return (
            <div style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 3, paddingBottom: 3, backgroundColor: 'white', boxShadow: '0px 2px 5px lightgrey', borderRadius: '10px', marginBottom: 5 }}>
              <td style={{ position: 'static', left: 20, maxWidth: '200px', width: '200px' }}>{s.cognome + ' ' + s.nome} </td>
              <td style={{ position: 'static', left: '220px' }}>
                <TextInput width='60px' 
                  style={{ borderBottom: '1px solid darkgrey', borderTop: '0px', borderLeft: '0px', borderRight: '0px', textAlign: 'center', backgroundColor: '' }}
                  value={this.studenti[index].valutazione != -1 ? this.studenti[index].valutazione : '-'}
                  onChange={(text) => { 
                    this.studenti[index].valutazione = text;
                    this.setState({});  
                  }} />
              </td> 
              { this.esame.type === '2' && (
                    <td style={{ position: 'static', left: '300px' }}>
                      <MyDatePicker inputStyle={{ borderTop: 0, borderLeft: 0, borderRight: 0, borderBottom: '1px solid darkgrey', backgroundColor: 'white', textAlign: 'center', width: '100px', marginTop: -10, marginBottom: -15 }} value={this.studenti[index].data} onChange={(data) => { 
                          var parsedDate = moment(data.getDate() + '-' + (data.getMonth() + 1) + '-' + data.getFullYear(), 'D-M-yyyy').format('DD-MM-yyyy');
                          this.studenti[index].data_str = parsedDate;
                          this.studenti[index].data = data;
                          this.setState({ });
                        }}
                        placeholder={t('data')} />
                    </td>
                  )}
            </div>
          );
        })}
        </table><br/>
        <FixButton title={t('salva')} callback={this.save.bind(this)} />

        <EditEsame key={Math.random()} show={this.state.editShow} titolo={this.esameName} data={this.esame.data} tipo={{ value: parseInt(this.esame.type), label: this.esame.type === '1' ? t('prova_scritta') : t('prova_orale') }} onOkClicked={async (tipo, data, titolo) => {

          const cookies = new Cookies();
          const username = cookies.get('username', { path: '/' });
          const token = cookies.get('token', { path: '/' });
          const currentCourse = cookies.get('currentCourse', { path: '/' });
          const currentEsame = cookies.get('currentEsame', { path: '/' });

          await editEsame(username, token, currentEsame, tipo, data, titolo);

          this.esami = await getEsami(username, token, currentCourse);
          this.esame = this.esami.find(e => e.id == currentEsame);
          this.esameName = this.esame.nome;

          this.setState({editShow: false});

          }}
          onCancel={() => {
            this.setState({editShow: false});
          }}
          />
    </div>);
  }

  async save () {

      console.error(this.studenti);

      const cookies = new Cookies();
      const username = cookies.get('username', { path: '/' });
      const token = cookies.get('token', { path: '/' });

      for (var i = 0; i < this.studenti.length; i++){
        var studente = this.studenti[i];
        var valutazione = parseInt(studente.valutazione);
        if (studente.valutazione != '-' && (isNaN(valutazione) || valutazione > 110 || valutazione < -1))  {
          Utils.showError (t('verifica_dati'));
          return;
        } 
        if (this.esame.type === '2' && studente.valutazione != -1 && studente.data === null) {
          Utils.showError(t('controlla_orale'));
          return;
        }
      }
      
      for (var i = 0; i < this.studenti.length; i++) {
        var studente = this.studenti[i];
        await setValutazione(username, token, this.corsoId, this.esame.id, studente.id, this.esame.type === '2' ? studente.data_str : '', studente.valutazione === -1 ? -1 : studente.valutazione);
      }

      Utils.showSuccess(t('esame_aggiornato'));
      window.history.go(-1);
      return false;
      
  }

}
